export default {
  getPaymentFilter: (state) => state.filter,
  getPaymentList: (state) => state.list,
  getPaymentResult: (state) => state.result,
  getPaymentValidation: (state) => state.validation,
};
